import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) throw new Error(body?.message || 'RIE request failed');
  return body.data;
}

export const responsibilityIntelligenceService = {
  listRules: () => unwrap<any[]>(api.get('/responsibility-intelligence/rules')),
  getPoDeliveryRule: () => unwrap<any>(api.get('/responsibility-intelligence/rules/po-delivery')),
  companyStatus: () =>
    unwrap<{
      enabled: boolean;
      growthEnabled?: boolean;
      shadowMode: boolean;
      companyId: string;
    }>(api.get('/responsibility-intelligence/company-status')),
  setCompanyStatus: (body: { enabled?: boolean; growthEnabled?: boolean; shadowMode?: boolean }) =>
    unwrap<{ enabled: boolean; growthEnabled?: boolean; shadowMode: boolean }>(
      api.put('/responsibility-intelligence/company-status', body)
    ),
  dryRun: () =>
    unwrap<{
      matching: number;
      approaching: number;
      dueToday: number;
      overdue: number;
      ownershipExceptions: number;
    }>(api.post('/responsibility-intelligence/dry-run')),
  runRecon: () => unwrap<any>(api.post('/responsibility-intelligence/recon')),
  suspendRule: (suspended: boolean) =>
    unwrap<any>(api.post('/responsibility-intelligence/rules/po-delivery/suspend', { suspended })),
  acknowledge: (id: string) => api.post(`/responsibility-intelligence/obligations/${id}/acknowledge`),
  assignFollowup: (id: string, followupUserId: string, note?: string) =>
    api.post(`/responsibility-intelligence/obligations/${id}/assign-followup`, { followupUserId, note }),
  diagnosePoDelivery: (po: string, userId?: string) =>
    unwrap<any>(
      api.get('/responsibility-intelligence/diagnostics/po-delivery', {
        params: { po, ...(userId ? { userId } : {}) },
      })
    ),
};
